import axios from 'axios';

const sendEmail = (name, email, phoneNumber, message) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/mail/send`, {
        name: name,
        email: email,
        phoneNumber: phoneNumber,
        message: message
    })
}

const submitUserRegistration = (data) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/users/create`, data)
}

const submitUserLogin = (data) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/users/login`, data)
}

const verifyToken = (token) => {
    return axios.post(`${process.env.REACT_APP_API_URL}/users/verifyToken`, {token: token})
}

const API = {
    sendEmail,
    submitUserRegistration,
    submitUserLogin,
    verifyToken
}

export default API